module.exports = __webpack_public_path__ + "static/media/bursts_11.78a0f023.svg";